import * as React from 'react'
export const SvgChevronUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} {...props}>
    <path d="M16.137 15L12 10.78 7.863 15 6.5 13.61 12 8l5.5 5.61z" />
  </svg>
)
export default SvgChevronUp
